import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=38c99ee2&scoped=true"
import script from "./ExchangeRate.vue?vue&type=script&lang=js"
export * from "./ExchangeRate.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRate.vue?vue&type=style&index=0&id=38c99ee2&prod&scoped=true&lang=css"
import style1 from "./ExchangeRate.vue?vue&type=style&index=1&id=38c99ee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c99ee2",
  null
  
)

export default component.exports